import React from 'react'
import './PropertySalesCompS2.scss'
import PropTypes from 'prop-types'
import { ReactComponent as SummaryLogo } from '@src/assets/summary_right_logo.svg'
import Comps from '@engine/comps'
import { connect } from 'react-redux'
import { formatNumber } from '@engine/utils/format'
import { EditButtonWrapper } from '@components/common'
import { EditPropertyDetails } from '../EditPropertyDetails/EditPropertyDetails'
import { propertySummarySales2 } from '@engine/dependencies/constants'
export class PropertySalesCompS2 extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isDialogOpen: false
        }
    }

    formatValue(col, value, rowIndex) {
        const maxIndex = this.props.summarydata.length - 1
        if (maxIndex === rowIndex && col.key === 'RSF') {
            return ''
        }
        if (col.value === 'propertyAddress' && (rowIndex === 0 && this.props.compsWithSubjectProperty)) {
            return ''
        }
        const result = formatNumber(col.value, value)
        if (!this.props.compsWithSubjectProperty && (col.value === 'propertyAddress' && !value)) {
            return ''
        }

        return result
    }

    handleDoneDialog = data => {
        this.props.editPropertyDetails({ type: 'summary', data: data.propertyFields, disclaimerTextData: data.disclaimerTextData })
    }

    handleEditButtonClick = () => {
        this.setState({
            isDialogOpen: !this.state.isDialogOpen
        })
    }

    getAddress = rowNumber => {
        const { propertyData } = this.props.summarydata[rowNumber]
        const { addressLine1, city, state, zipCode } = propertyData
        let addressLineOne
        if (addressLine1 && addressLine1.charAt(addressLine1.length - 1) === ',') {
            addressLineOne = addressLine1.slice(0, addressLine1.length - 1)
        }

        return (
            <>
                {Object.keys(propertyData)?.length > 0 &&
                    <div className="property-info__address">
                        <span>{addressLineOne}</span>
                        <span>{city}, {state}{' '} {zipCode}</span>
                    </div>
                }
            </>
        )
    }

    chunkList = (list, chunkSize) => {
        const listLength = list.length
        const isLargeList = listLength > chunkSize + 1
        const tempList = isLargeList ? [] : [list]
        if (isLargeList) {
            for (let ind = 0; ind < listLength; ind += chunkSize) {
                const newChunk = list.slice(ind, ind + chunkSize)
                tempList.push(newChunk)
            }
        }

        return tempList
    }

    addHeaderRow = (list, columns) =>
        list.map(property => {
            const values = Object.keys(property).reduce((propObj, col) => {
                if (
                    columns.some(
                        colHeader => colHeader.value === col
                    )
                ) {
                    propObj[col] = property[col]
                }

                return propObj
            }, {})

            return values
        })

    addFooterRow = list => {
        const summaryTableLastRow = {
            propertyType: '',
            name: 'Total / Averages',
            city: '',
            propertyAddress: '',
            units: '',
            yearBuilt: '',
            yearRen: '',
            mostRecentSaleDate: '',
            grossRentMultiplier: '',
            state: ''
        }
        for (const key in summaryTableLastRow) {
            if (summaryTableLastRow.hasOwnProperty(key)) {
                list[list.length - 1][key] = summaryTableLastRow[key]
            }
        }
    }

    render() {
        const { summarydata, hasBranding, hasPageTitle, themeColors, summaryTableColumns, summaryDisclaimerText, isSubjectPropertyDeleted } = this.props
        const PAGE_HEADER_SALES = 'COMPARABLE SALES PROPERTIES SUMMARY'
        const dialogProperties = { ...propertySummarySales2 }
        dialogProperties.propertyFields = summaryTableColumns
        const contentNote = 'Select none to hide labels. To change the column order, drag and drop a field'
        const dialogTitle = 'Property Summary'
        const columnsWithKeys = summaryTableColumns.filter(col => col.key !== 'NA')
        const columns_to_be_displayed = isSubjectPropertyDeleted ? columnsWithKeys.filter(col => col.key !== 'Distance') : columnsWithKeys
        columns_to_be_displayed.unshift({ key: '', value: 'propertyType' })
        const rowsPerTable = 10

        const chunkData = this.chunkList(summarydata, rowsPerTable)
        const pageList = []

        if (chunkData?.length > 1) {
            chunkData.forEach((list, ind) => {
                const cmp_props = this.addHeaderRow(list, columns_to_be_displayed)
                if (ind === chunkData.length - 1) {
                    this.addFooterRow(cmp_props)
                }
                pageList.push(cmp_props)
            })
        } else {
            const cmp_props = this.addHeaderRow(summarydata, columns_to_be_displayed)
            if (cmp_props && cmp_props.length > 2) {
                this.addFooterRow(cmp_props)
            }
            pageList.push(cmp_props)
        }

        const subjectPropMarkerStyle = {
            backgroundColor: themeColors.summarySubjectBackgroundColor,
            color: themeColors.summarySubjectTextColor,
            borderColor: themeColors.summarySubjectBorderColor,
            // fontFamily: '\'Montserrat\', sans-serif',
            fontFamily: '\'DIN Pro Light\'',
            fontSize: '10px'
        }

        const subjectRowBackgroundStyle = {
            backgroundColor: themeColors.summaryRowBackgroundColor
        }

        const comparablePropMarkerStyle = {
            backgroundColor: themeColors.summaryComparableBackgroundColor,
            color: themeColors.summaryComparableTextColor,
            border: `1px solid ${themeColors.summaryComparableBorderColor}`,
            // fontFamily: '\'Montserrat\', sans-serif',
            fontFamily: '\'DIN Pro Light\'',
            fontWeight: '500',
            fontSize: '10px'
        }

        return (
            <div
                className={(hasBranding || hasPageTitle) ? 'property-sales-comps-S2' : 'no-margin-property-sales-comps-view-S2'}
            >
                {pageList && pageList.map((data, ind) => (
                    < div
                        data-testid="summary-report"
                        className="summary-report-view"
                        key={ind}
                    >
                        <div className="summary-header">
                            <span style={{ 'color': themeColors.globalColor }}>{hasPageTitle && PAGE_HEADER_SALES}</span>
                            {hasBranding && (
                                <SummaryLogo data-testid="logo-long" className="summary_logo" />
                            )}
                        </div>
                        <div data-testid="summuary-table" className="summary-table-s2">
                            <EditButtonWrapper handleEditButtonClick={this.handleEditButtonClick} dataTestId="edit-summary-report-button">
                                <table>
                                    <tbody>
                                        <tr>
                                            {columns_to_be_displayed.map((column, index) => (
                                                <th key={index} className={column.key}>{column.key}</th>
                                            ))}
                                        </tr>
                                        {data &&
                                            data.map((row, i) => (
                                                <tr key={i} style={ind === 0 && row.propertyType.toString().includes('S') ? subjectRowBackgroundStyle : {}} className={ind > 0 && i === 0 ? 'next-table-row' : (ind === pageList.length - 1 && i === data.length - 1) ? 'weighted-avg-row' : ''}>
                                                    {columns_to_be_displayed.map((col, j) => (
                                                        <td key={j}>
                                                            {col.value === 'propertyType' ? (
                                                                ind === 0 && row.propertyType.toString().includes('S') ? (
                                                                    <div className="table_row_subject" style={subjectPropMarkerStyle}>
                                                                        {this.formatValue(col, row[col.value])}
                                                                    </div>
                                                                ) : ind === pageList.length - 1 && i === data.length - 1 ? (
                                                                    <span>{this.formatValue(col, row[col.value])}</span>
                                                                ) : (
                                                                            <div className="table_row_value" style={comparablePropMarkerStyle}>
                                                                                {this.formatValue(col, row[col.value])}
                                                                            </div>
                                                                        )
                                                            ) : col.value === 'name' ? (
                                                                <>
                                                                    <span className="prop-name">{this.formatValue(col, row[col.value], i + (ind * rowsPerTable))}</span>
                                                                    {this.getAddress(i + (ind * rowsPerTable))}
                                                                </>
                                                            ) : (
                                                                        <span>{this.formatValue(col, row[col.value], i + (ind * rowsPerTable))}</span>
                                                                    )
                                                            }
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {summaryDisclaimerText.showDisclaimer && (
                                    <div className="summary-disclaimer-text">{summaryDisclaimerText.disclaimerText}</div>
                                )}
                            </EditButtonWrapper>
                        </div>
                    </div >
                ))}
                {
                    this.state.isDialogOpen ? (
                        <EditPropertyDetails
                            isDialogOpen={this.state.isDialogOpen}
                            closeEditPopup={this.handleEditButtonClick}
                            doneDialog={this.handleDoneDialog}
                            contentNote={contentNote}
                            dialogTitle={dialogTitle}
                            dialogProperties={dialogProperties}
                            isDisclaimerNeeded={true}
                            summaryDisclaimerText={summaryDisclaimerText}
                        />
                    ) : ''
                }
            </div>
        )
    }
}

PropertySalesCompS2.propTypes = {
    hasBranding: PropTypes.bool,
    hasPageTitle: PropTypes.bool,
    summarydata: PropTypes.array,
    themeColors: PropTypes.object,
    summaryTableColumns: PropTypes.array,
    editPropertyDetails: PropTypes.func,
    summaryDisclaimerText: PropTypes.object,
    compsWithSubjectProperty: PropTypes.bool,
    isSubjectPropertyDeleted: PropTypes.bool
}

const mapStateToProps = state => ({
    themeColors: Comps.selectors.comps.themeColors(state),
    summaryTableColumns: Comps.selectors.comps.summaryTableColumns(state),
    summaryDisclaimerText: Comps.selectors.comps.summaryDisclaimerText(state),
    compsWithSubjectProperty: Comps.selectors.comps.compsWithSubjectProperty(state),
    isSubjectPropertyDeleted: Comps.selectors.comps.isSubjectPropertyDeleted(state)
})

const mapDispatchToProps = {
    editPropertyDetails: Comps.actions.editPropertyDetails
}

export default connect(mapStateToProps, mapDispatchToProps)(PropertySalesCompS2)
